import React, { Fragment } from 'react';
import { Box, Button, Divider } from '@mui/material';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { BackrsTextField } from '../../atoms/BackrsTextField/BackrsTextField';
import appColors from '../../app_colors';

const buttonStyle = {
  mx: 2,
  borderRadius: 6,
  textTransform: 'none',
  fontSize: '1.125rem',
  fontWeight: 700,
  lineHeight: '2rem',
  backgroundColor: appColors.buttons.secondaryBackground,
  boxShadow: 'none',
};

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 8,
};

export const BackrsForm = ({
  fields,
  onSubmit,
  defaultValues,
  buttonLabel,
  children,
  methods,
}) => {
  const defaultMethods = useForm({ defaultValues });
  const methodsToUse = methods || defaultMethods;
  const { formState } = methodsToUse;

  const stopPropage = (callback) => (e) => {
    e.stopPropagation();
    e.preventDefault();
    callback();
  };

  const handleSubmit = methodsToUse.handleSubmit((data) => {
    onSubmit(data);
  });

  return (
    <FormProvider {...methodsToUse}>
      <Box component="form" onSubmit={stopPropage(handleSubmit)} noValidate mt={1} width="100%">
        {fields.map((field) => (
          <Fragment key={field.id}>
            {field.divider && <Divider sx={{ my: 2 }} />}
            <Controller
              key={field.name}
              name={field.name}
              control={methodsToUse.control}
              rules={field.rules}
              render={({ field: controllerField, fieldState: { error } }) => (
                <BackrsTextField
                  id={field.name}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  placeholder={field.placeholder}
                  icon={field.icon}
                  autoComplete={field.autoComplete}
                  autoFocus={field.autoFocus}
                  value={controllerField.value}
                  onChange={controllerField.onChange}
                  inputProps={field.inputProps}
                  sx={{
                    mb: 1,
                    backgroundColor: appColors.inputs.primaryBackground,
                  }}
                  error={error?.message}
                  disabled={field?.disabled}
                />
              )}
            />
          </Fragment>
        ))}
        {children}
        <Box sx={buttonContainerStyle}>
          <Button type="submit" fullWidth variant="contained" sx={buttonStyle} disabled={!formState.isValid}>
            {buttonLabel}
          </Button>
        </Box>
      </Box>
    </FormProvider>
  );
};
